<template lang="pug">
  .task-messages
    // Comments
    b-notification(v-if="messages.$state.loading", :closable="false")
      p.py-30
      b-loading(:is-full-page="false", active)

    template(v-else)
      .task-message-row(v-for="message in messages.items", :key="message.id", :class="messageClassName(message)")
        .mb-5
          a(:name="'comment' + message.id" :id="'comment' + message.id", class="message-scroll-top")
          strong.message-author
            user-name(:user="message.user", with-label)
          .is-pulled-right
            b-tooltip(:label="dateToNow(message.created_at, true)")
              small.has-text-grey {{ message.created_at | dateFormat }}
            b-tooltip(:label="'Ссылка на комментарий #' + message.id")
              a(:href="getCommentUrl(message.id)")
                | &nbsp;&nbsp;#

        div(:class="'box mb-20 ' + (selectedCommentId===message.id ? 'has-background-warning-light' : '')")
          template(v-if="message.new_status")
            //- span.tag.is-rounded.is-grey Новый статус
            task-status.tag.is-rounded.is-pulled-right(:status="message.new_status", alt-style)

          .content.mb-0(v-if="message.message", v-html="message.messageHtml")
          .content.mb-0(v-else-if="message.new_status")
            em.has-text-grey Статус задачи изменен
          ui-files.mt-5(v-if="message.files", :files="message.files")

    //- Новое сообщение
    template(v-if="task.active==1")
      .field.mt-50.mb-10
        label.label
          b-icon.mr-5(icon="comment")
          span Написать комментарий
        p.has-text-right.is-clickable.mt-24px(@click="clearMessage") очистить

        div
          b-loading(:is-full-page="false", :active="newMessage.$state.saving")
          // Form
          b-input(
            type="textarea",
            v-model="newMessage.message",
            v-meta-ctrl-enter="sendMessage",
            placeholder="Комментарий…"
          )

          .mt-10
            b-field.grouped.is-pulled-right
              template(v-if="user.isSupport")
                select-task-status.mr-10(
                  v-model="newMessage.new_status_id",
                  :filter="taskStatusFilter",
                  position="is-top-left",
                  with-reset
                )
              b-button(type="is-primary", icon-left="send", @click="sendMessage", :disabled="!allowSendNewMessage") Отправить

            b-field.grouped
              ui-upload(v-model="files", listStyle="is-light", multiple, simple, wide)
            template
              span.is-clickable.is-inline-block.pt-1.ml-5.is-size-5(v-for="smile in smiles" @click="addSmile(smile)") {{ smile }}
            // Изменение статуса

      template(v-if="user.isSupport")
        .field.mb-50.mt-20
          b-tooltip(:label="template.help ? template.help : template.full" v-for="template in messageTemplates")
            span.is-clickable.pr-6(@click="addTemplate(template)") {{ template.short }}

    template(v-if="task.active==0")
      .box: .content
        p: b Нельзя писать комментарии в закрытые тикеты.
        p: i Заведите новый тикет или заново откройте текущий
</template>

<script>
import {mapGetters} from 'vuex';
import DateHelper from '@/helpers/date';
import TaskMessage from '@/models/TaskMessage';
import Task from '@/models/Task';
import TaskFile from '@/models/TaskFile';

const TASK_MESSAGE_API_RELATIONS = 'user,newStatus,files';

export default {
  name: 'task-messages',

  props: {
    task: Task,
  },

  data: () => ({
    messages: TaskMessage.collection(),
    newMessage: null,
    files: [],
    selectedCommentId: null,
    renderCount: 0,
    smiles: ['👌', '👍', '🙏', '😳', '😉', '😊', '✋'],
    messageTemplates: [
      {
        short: `Добрый день`,
        full: `Добрый день
`, // важно
      },
      {
        short: 'Спасибо за обращение...',
        full: 'Спасибо за обращение, хорошего дня!',
      },
      {
        short: 'Уточню...',
        full: 'Уточню информацию у разработчиков, и вернусь к Вам с ответом',
      },
      {
        short: 'Документация...',
        help: 'Вы можете посмотреть...',
        full: 'Вы можете посмотреть дополнительную информацию в документации: ',
      },
      {
        short: 'К Олегу',
        help: 'В связи с тем, что данная задача выходит за рамки техподдержки...',
        full: `В связи с тем, что данная задача выходит за рамки техподдержки и большим количеством текущих задач, мы не можем начать решать данный вопрос в ближайшие несколько месяцев. Вы можете обсудить этот вопрос с Олегом Виколом по тел +7(925)058-48-83 olegv@med-pred.ru`,
      },
    ],
  }),

  computed: {
    ...mapGetters(['user']),

    allowSendNewMessage() {
      return this.newMessage.message || this.newMessage.new_status_id || (this.files && this.files.length);
    },
  },

  methods: {
    addSmile(smile) {
      this.newMessage.message = this.newMessage.message + ' ' + smile + ' ';
    },

    addTemplate(template) {
      this.newMessage.message = this.newMessage.message + ' ' + template.full + ' ';
    },

    clearMessage() {
      this.newMessage.message = '';
    },

    dateToNow: DateHelper.dateToNow,

    initNewMessage() {
      this.newMessage = new TaskMessage({
        task_id: this.task.id,
      });
      this.newMessage.user = this.user;
      this.files = [];
    },

    loadState() {
      this.messages.$fetch({
        include: TASK_MESSAGE_API_RELATIONS,
        filter: {task_id: this.task.id},
      });
    },

    messageClassName({user_id, user}) {
      return {
        'is-my-comment': user_id === this.user.id,
        'is-support-comment': user ? user.isSupport : false,
      };
    },

    taskStatusFilter({id, type}) {
      return id !== this.task.status_id && type !== 'reopen' && type !== 'new';
    },

    getCommentUrl(commentId) {
      return this.$router.resolve({
        name: this.$route.name,
        params: {id: this.task.id},
      }).href + '#comment' + commentId;
    },

    async sendMessage() {
      if (!this.allowSendNewMessage) {
        return;
      }

      try {
        let {data} = await this.newMessage.$save({include: TASK_MESSAGE_API_RELATIONS});
        let taskMessage = new TaskMessage(data);
        taskMessage.user = this.user;
        taskMessage.files = TaskFile.collection();
        this.messages.add(taskMessage);
        this.files.forEach(file => {
          let taskFile = TaskFile.makeFromFile(file, {
            task_id: this.task.id,
            task_message_id: taskMessage.id,
          });
          taskFile.$save().then(({data}) => {
            taskMessage.files.add(data);
          });
        });
      } finally {
        this.initNewMessage();
      }
    },
  },

  created() {
    this.initNewMessage();
    this.loadState();
  },

  updated: function () {
    this.$nextTick(() => {
      this.renderCount++;
      if (this.renderCount === 1) {
        setTimeout(() => {
          if (this.$route.hash && this.$route.hash.length > 1) {
            this.selectedCommentId = +this.$route.hash.substring("#comment".length);
            document.querySelector(this.$route.hash).scrollIntoView({block: 'start', behavior: 'smooth'});
          }
        }, 200);
      }
    })
  }
};
</script>

<style lang="scss">
.task-messages {
  .task-status {
    margin-top: -4px;
  }

  .is-my-comment .box {
    background: rgb(220, 236, 217);
    color: rgb(68, 73, 68);
  }

  .message-scroll-top {
    scroll-margin-top: 70px;
  }

  .ml-5 {
    margin-right: 1.5rem;
  }
}

.mt-24px {
  margin-top: -24px;
}
</style>
